
import { z } from 'zod';

const answerSchema = z.object({
    answer: z.union([
        z.string().min(1, "Please select an answer"),
        z.null(),
        z.undefined()
    ]).refine((val) => val !== null && val !== undefined && val !== "", {
        message: "Please select an answer"
    }), type: z.string().optional()
});

const testSchema = z.object({
    testType: z.string(),
    testTitle: z.string().optional(),
    answers: z.record(z.string(), answerSchema).optional(),
    comments: z.string().optional().nullable()
});

export const postTestSchema = z.object({
    tenantId: z.coerce.number().positive(),
    userId: z.coerce.number().positive().optional(),
    applicantName: z.string().regex(/^[^0-9]*$/, "Name cannot contain digits").min(1, "Orientee Name is required"),
    testDate: z.string().min(1, "Date is required"),
    applicantSignature: z.string().optional().nullable(),
    applicantSignedAt: z.string().optional().nullable(),
    tests: z.array(testSchema).length(4, "All 4 tests are required") //need to check
});
